export const GST_RATE = 0.18;

// Sub total = sum of (quote price x quantity); grand total adds 18% GST
export const computeGstTotals = (parts = []) => {
  const subTotal = (parts || []).reduce(
    (sum, part) => sum + (Number(part?.quotePrice) || 0) * (Number(part?.quantity) || 0),
    0
  );
  const gst = subTotal * GST_RATE;
  return { subTotal, gst, grandTotal: subTotal + gst };
};

export const formatINR = (value) =>
  `₹${(Number(value) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
